export default "__VITE_ASSET__79b7f303__"